import Delegate from "//legramme-qa.com/cdn/shop/t/11/assets/ftdomdelegate.min.js?v=167457923630348017651772640318";

export class ProductConfigSection extends HTMLElement {
    connectedCallback() {
      this.tabsCustom           = this.querySelectorAll('[data-action="change-tab-custom"]');
      this.allOptionsTabs       = Array.from(document.querySelectorAll('.product-configurator-product-options'));
      this.allOptionsWeigth     = Array.from(document.querySelectorAll('.product-configurator-product__weights-container'));
      this.currentForm          = document.querySelector('.product-configurator-product-form');
      this.currentType          = this.currentForm.querySelector('input[type="hidden"][name="type"]').value;
      this.filterKeys           = ['material', 'finish', 'pattern', 'tour', 'diamants', 'weight', 'type', 'color', 'typology'];
      this.productsArray        = JSON.parse(document.querySelector('[data-json-products]').innerHTML);
      this.pushCables           = document.querySelectorAll('[href*="#push-cables"]');
  
      this._attachListeners();
      this._initFilterProducts();


      // globaly open pop up
      let that = this;
      this.pushCables.forEach(function(link, index) {
        link.addEventListener('click', function (event) {
          that._openPop(event);
        });
      });
      
    }
  
    _attachListeners() {

      // toggle popup
      new Delegate(this).on('click', '[data-action="close-custom"]', this._closePop.bind(this));
  
      // change tab
      new Delegate(this).on('click', '[data-action="change-tab-custom"]', this._changeTab.bind(this));
  
      // change size
      new Delegate(this).on('click', 'input[type="radio"][name="weight"]', this._getMatchedProducts.bind(this));
  
      // product form on change
      new Delegate(this).on('change', '.product-configurator-product-form', this._productFormChanged.bind(this));
  
      let that = this;
      window.addEventListener('resize', function() {
        that._setPushHeight();
      });
    }
  
    /**
     * INIT FILTER PRODUCTS
     */
    _initFilterProducts() {
      // get the first value
      let firstInput = this.currentForm.querySelector('input[type="radio"]');
      if (firstInput) {
        // init the filter
        this._disableUnmatchedFilters(firstInput.getAttribute('name'), firstInput.value);
      }
    }
  
    /**
     * PRODUCT FROM CHANGED
     */
    _productFormChanged(event) {
      let target  = event.target;
      let key     = target.getAttribute('name');
      let value   = target.value;
  
      this._disableUnmatchedFilters(key, value);
    }
  
  
    /**
     * DISABLE UNMATCHED FILTERS
     */
    _disableUnmatchedFilters(key, value) {
      let that = this;
  
      // disable all radios
      let allInputs = this.querySelectorAll('form[data-type="'+this.currentType+'"] input[type="radio"]:not([name="'+key+'"]):not([name="material"])');
      if (allInputs.length > 0) {
        for (let i = 0; i < allInputs.length; i++) {
          allInputs[i].setAttribute('disabled', 'disabled');
        }
      }
  
      this.currentResults = this.productsArray.filter(function(e) {
        return e[key] === value;
      });
  
      if (this.currentForm.id === 'form-1-cable') {
        let currentMaterial = this.querySelector('form[data-type="'+this.currentType+'"] input[type="radio"][name="material"]:checked');
        let currentNbTours  = this.querySelector('form[data-type="'+this.currentType+'"] input[type="radio"][name="tour"]:checked');
        this.currentResults = this.currentResults.filter(function(e) {
  
          // remove all diamants if not simple tour
          if (currentNbTours.value !== 'simple' && e['diamants'] !== 'sans') {
            return false;
          }
  
          return e['material'] === currentMaterial.value;
        });
      }
  
      // allow only available filters
      for (let i = 0; i < this.filterKeys.length; i++) {
        if (this.filterKeys[i] !== key) {
          this.currentResults.filter(function(e) {
  
            let inputs = that.querySelectorAll('form[data-type="'+that.currentType+'"] input[type="radio"][name="'+that.filterKeys[i]+'"]');
            if (inputs.length > 0) {
              for (let j = 0; j < inputs.length; j++) {
  
                if (inputs[j].value === e[that.filterKeys[i]]) {
                  inputs[j].removeAttribute('disabled');
                  return inputs[j];
                }
              }
            }
          })
        }
      }
  
      this._checkIfAllFiltersAreChecked();
  
      this._getWeightsFromMatchedProducts();
    }
  
    /**
     * CHECK IF ALL FILTERS ARE CHECKED
     */
    _checkIfAllFiltersAreChecked() {
      let formSerialized = $(this.currentForm).serialize().split('&');
  
      for (let i = 0; i < this.filterKeys.length; i++) {
        let allChecked = false;
        for (let j = 0; j < formSerialized.length; j++) {
          if (formSerialized[j].indexOf(this.filterKeys[i]) > -1) {
            allChecked = true;
          }
        }
  
        // check the first element available
        if (!allChecked) {
          let items = this.querySelectorAll('form[data-type="'+this.currentType+'"] input[name="'+this.filterKeys[i]+'"]');
          if (items.length > 0) {
            for (let i = 0; i < items.length; i++) {
              if (items[i].disabled) {
              } else {
                items[i].setAttribute('checked', 'checked');
                items[i].checked = true;
                break;
              }
            }
          }
        }
      }
    }
  
    /**
     * GET WEIGHT FROM MATCHED PRODUCTS
     */
    _getWeightsFromMatchedProducts() {
      // get listed products form form
      let matchedProducts = this._getProductsFromForm(true);
  
      // disable all weights
      let inputsWeight = this.querySelectorAll('form[data-type="'+this.currentType+'"] input[type="radio"][name="weight"]');
      if (inputsWeight.length > 0) {
        for (let i = 0; i < inputsWeight.length; i++) {
          inputsWeight[i].setAttribute('disabled', 'disabled');
          inputsWeight[i].parentElement.classList.add('hide');
        }
      }
  
      for (let j = 0; j < matchedProducts.length; j++) {
        for (let k = 0; k < inputsWeight.length; k++) {
          if (inputsWeight[k].value === matchedProducts[j].weight) {
            inputsWeight[k].removeAttribute('disabled');
            inputsWeight[k].parentElement.classList.remove('hide');
          }
        }
      }
  
      this._checkIfAllFiltersAreChecked();
      this._getMatchedProducts();
    }
  
  
    /**
     * GET PRODUCTS FROM CURRENT FORM
     */
    _getProductsFromForm(excludeWeight) {
      let formSerialized = $(this.currentForm).serialize().split('&');
  
      // remove weight from array
      if (excludeWeight) {
        formSerialized.shift();
      }
  
      // get matched products
      let matchedProduct = [];
      matchedProduct = this.productsArray.filter(function(product) {
        let productFound = false;
  
        for (let j = 0; j < formSerialized.length; j++) {
          let formData = formSerialized[j].split('=');
  
          if (product.hasOwnProperty(formData[0])) {
            if (product[formData[0]] === formData[1]) {
              productFound = true;
            } else {
              productFound = false;
              break;
            }
          }
        }
  
        if (productFound) {
          return product;
        }
      });
  
      return matchedProduct;
    }
  
  
    /**
     * GET MATCHED PRODUCTS
     */
    _getMatchedProducts() {
      let matchedProduct = this._getProductsFromForm();
      if (matchedProduct.length === 1) {
        this._setProductDetails(matchedProduct[0]);
      }
    }
  
    /**
     * SET PRODUCT DETAILS
     */
    _setProductDetails(product) {
  
      // change the product title
      let productTitle = document.querySelectorAll('[data-product-name]');
      if (productTitle.length > 0) {
        for (let i = 0; i < productTitle.length; i++) {
          productTitle[i].innerText = product.title;
        }
      }
  
      // change the product price
      let productPrice = document.querySelectorAll('[data-product-price]');
      if (productPrice.length > 0) {
        for (let i = 0; i < productPrice.length; i++) {
          productPrice[i].innerHTML = product.price;
        }
      }
  
      // set the product link
      let discoverButton = document.querySelectorAll('[data-product-link]');
      if (discoverButton.length > 0) {
        for (let i = 0; i < discoverButton.length; i++) {
          discoverButton[i].setAttribute('href', '/products/'+product.handle)
        }
      }
  
      //set the product image
      let productImage = document.querySelectorAll('[data-product-image]');
      if (productImage.length > 0) {
        for (let i = 0; i < productImage.length; i++) {
          productImage[i].setAttribute('src', product.image);
        }
      }
  
    }
  
    _openPop(event) {
      event.preventDefault();
      
      document.querySelector('body').classList.add('hide-scrollbar');
      this.popPersonnalisation = document.querySelector('.product-configurator');
      this.popPersonnalisation.classList.add('active');
      this._setPushHeight(this.popPersonnalisation);
    }

    _closePop(event) {
      event.preventDefault();

      this.popPersonnalisation = document.querySelector('.product-configurator');
      this.popPersonnalisation.classList.remove('active');
    }
  
    _setPushHeight() {
      if(this.popPersonnalisation) {
        this.popPersonnalisation.style.height = window.innerHeight + 'px';
      }
  
      // set max width to image container
      let imageContainer = this.querySelector('.product-configurator-product__visual-container');
      let productParamsBlock = this.querySelector('.product-configurator-product-block--grey');
      if (imageContainer && productParamsBlock) {
        imageContainer.style.width = window.innerHeight - productParamsBlock.offsetHeight - 68 - 71 + 'px';
      }
    }
  
    _selectWeight(event) {
      event.preventDefault();
      event.target.classList.add('active');
    }
  
    _changeTab(event, target) {
      event.preventDefault();
  
      // Initialization tabs and contents
      for (let item of Array.from(this.tabsCustom)) {
        if(item.classList.contains('active')) {
          item.classList.remove('active');
        }
      }
  
      // Forms
      for (let item of this.allOptionsTabs) {
        if(item.classList.contains('active')) {
          item.classList.remove('active');
        }
      }
  
      // Options weigth
      for (let item of this.allOptionsWeigth) {
        if(item.classList.contains('active')) {
          item.classList.remove('active');
        }
      }
  
      // Active tab selected
      target.classList.add('active');
  
      // Active option selected
      this.selectedOption = target.getAttribute('data-id');
      this.selectedContent = this.allOptionsTabs.find(option => option.getAttribute('id') === this.selectedOption);
      this.selectedContent.classList.add('active');
  
      // Active weight container selected
      this.selectedWeight = target.getAttribute('data-form');
      this.selectedContainer = this.allOptionsWeigth.find(weight => weight.getAttribute('id') === this.selectedWeight);
      this.selectedContainer.classList.add('active');
  
      // change current form
      let currentId = target.getAttribute('data-id');
      this.currentForm = document.getElementById(currentId).querySelector('form');
      this.currentType = this.currentForm.getAttribute('data-type');
  
      // init filter
      this._initFilterProducts();
    }
}

try {
  window.customElements.define('product-configurator-section', ProductConfigSection);
} catch(e) {}